class CartPromotionDetails extends HTMLElement {
  constructor() {
    super();
    this._onOpen = this._onOpen.bind(this);
    this._onClose = this._onClose.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
  }

  connectedCallback() {
    this._trigger = this.querySelector('[data-cart-promo-open]');
    this._sheet = this.querySelector('[data-cart-promo-sheet]');
    this._closeButtons = this.querySelectorAll('[data-cart-promo-close]');

    this._trigger?.addEventListener('click', this._onOpen);
    this._closeButtons.forEach((btn) => {
      btn.addEventListener('click', this._onClose);
    });
    document.addEventListener('keydown', this._onKeyDown);
  }

  disconnectedCallback() {
    this._trigger?.removeEventListener('click', this._onOpen);
    this._closeButtons?.forEach((btn) => {
      btn.removeEventListener('click', this._onClose);
    });
    document.removeEventListener('keydown', this._onKeyDown);
  }

  get isOpen() {
    return this.classList.contains('is-open');
  }

  open() {
    // Desktop cart shows Order Summary inline — no sheet toggle
    if (
      this.dataset.context === 'cart' &&
      window.matchMedia('(min-width: 750px)').matches
    ) {
      return;
    }
    if (!this._sheet || this.isOpen) return;

    // Close other promo sheets (drawer + cart page)
    document.querySelectorAll('cart-promotion-details.is-open').forEach((el) => {
      if (el !== this) el.close();
    });

    this._sheet.hidden = false;
    this.classList.add('is-open');
    this._trigger?.setAttribute('aria-expanded', 'true');
  }

  close() {
    if (!this._sheet || !this.isOpen) return;
    this.classList.remove('is-open');
    this._trigger?.setAttribute('aria-expanded', 'false');
    this._sheet.hidden = true;
  }

  toggle() {
    if (this.isOpen) this.close();
    else this.open();
  }

  _onOpen(event) {
    event.preventDefault();
    this.toggle();
  }

  _onClose(event) {
    event.preventDefault();
    this.close();
  }

  _onKeyDown(event) {
    if (event.key === 'Escape' && this.isOpen) {
      this.close();
      this._trigger?.focus();
    }
  }
}

if (!customElements.get('cart-promotion-details')) {
  customElements.define('cart-promotion-details', CartPromotionDetails);
}
